module.exports = ".menu mat-nav-list mat-list-item{\r\n\tfont-family: sans-serif;\r\n\tfont-size: 17px; \r\n}\r\n.content{\r\n\tfont-size: 17px;\r\n\tfont-family: serif;\r\n}\r\nh2, h3{\r\n\tfont-family: serif;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/main.style.css
// module id = ./src/app/components/main.style.css
// module chunks = main